export default __webpack_public_path__ + "static/media/bigland.9898de92.gif";